// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"237":"bc16dd9a","263":"0ed2b39b","442":"19c03a45"}[chunkId] + ".css";
};